import ZoomOut from './zoom-out'
import ZoomOutLeft from './zoom-out-left'
import ZoomOutRight from './zoom-out-right'
import ZoomOutDown from './zoom-out-down'
import ZoomOutUp from './zoom-out-up'

export default {
  ZoomOut,
  ZoomOutDown,
  ZoomOutLeft,
  ZoomOutRight,
  ZoomOutUp
}



// WEBPACK FOOTER //
// ./src/libs/animated-vue/transitions/zoom-exits/index.js